import { LoadsProfessionalPositionWithIndustry } from "@/types/professionalPosition";

export function sumYearsOfWorkExperience(
    positions: LoadsProfessionalPositionWithIndustry["professional_positions"],
): number {
    return positions.reduce(
        (total, position) => total + position.years_at_role,
        0,
    );
}
